export default __webpack_public_path__ + "static/media/loader.80c8fbcd.svg";